import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';

import AriPage from './ari';

import VoucherWebisteIntregation from './integration/components/VoucherIntegrationList';

// import TicketsPage from './tickets';
import PropInfoPage from './propinfo';
import DiscountsPage from './discounts';
import FinancePage from './finance';
import AdminPage from './admin';
import IntegrationPage from './integration';
import IntegrationList from './integration/components/IntegrationList';
// import GroupsPage from './groups';
// import PropertiesPage from './properties';
import UsersPage from './users';
import SuperAdmin from './superAdmin';
import BillingPage from './billing';

import BotDialogPage from './botdialogs';
import AccommodationProvidersDialogPage from './botdialogs/AccommodationProviders';
import DoctorsDialogPage from './botdialogs/Doctors';
import HolidayHomesDialogPage from './botdialogs/HolidayHomes';
import HolidaysParkDialogPage from './botdialogs/HolidaysPark';
import QuarantineBotDialogPage from './botdialogs/QuarantineBot';
import SalonsDialogPage from './botdialogs/Salons';
import TourismDialogPage from './botdialogs/Tourism';
import VirtualVetNurseDialogPage from './botdialogs/VirtualVetNurse';
import RetirementHomesDialogPage from './botdialogs/RetirementHomes';
import VouchersPage from './discounts/vouchers';
import OrdersPage from './discounts/orders';
import StripePage from './stripe';
import InvitationPage from './discounts/invitations';
import Insights from './discounts/Insights';
import EmbedVoucherIntregationDetail from './integration/components/EmbedVoucherIntregationList';
import VoucherStandAlonePageIntegrationList from './integration/components/VoucherStandAlonePageIntegrationList';
import Statement from './discounts/statements';
import StandardStripe from './standardStripe';
import CloudBeds from './cloudBeds';
import Tokens from './cloudBeds/tokens';
import View from  './view';
const Pages = ({ match }) => (
  <div className="dashboard-wrapper">
    <Switch>
      <Redirect exact from={`${match.url}/`} to={`${match.url}/data-list`} />
      <Route path={`${match.url}/ari`} component={AriPage} />
     


      {/* <Route path={`${match.url}/tickets`} component={TicketsPage} /> */}
      <Route path={`${match.url}/propinfo`} component={PropInfoPage} />
      <Route path={`${match.url}/rate-promos`} component={DiscountsPage} />
      <Route path={`${match.url}/finance`} component={FinancePage} />
      <Route path={`${match.url}/integration`} component={IntegrationPage} />
      <Route
        path={`${match.url}/integrationdetail/:id`}
        component={IntegrationList}
      />
      <Route
        path={`${match.url}/embedintegrationdetail/:id`}
        component={EmbedVoucherIntregationDetail}
      />
      <Route
        path={`${match.url}/standaloneintegrationdetail/:id`}
        component={VoucherStandAlonePageIntegrationList}
      />
     
      <Route
        path={`${match.url}/voucherintegrationdetail/:id`}
        component={VoucherWebisteIntregation}
      />
      <Route path={`${match.url}/admin`} component={AdminPage} />
      {/* <Route path={`${match.url}/groups`} component={GroupsPage} />
      <Route path={`${match.url}/properties`} component={PropertiesPage} /> */}
      <Route path={`${match.url}/users`} component={UsersPage} />    
      <Route path={`${match.url}/redeemVouchers/:code`} component={View} />       
      <Route path={`${match.url}/redeemVouchers`} component={View} /> 
      <Route path={`${match.url}/vouchers`} component={VouchersPage} />
      <Route path={`${match.url}/orders`} component={OrdersPage} />
      <Route path={`${match.url}/cloudBeds`} component={CloudBeds} />
      <Route path={`${match.url}/tokens`} component={Tokens} />
      <Route path={`${match.url}/insights`} component={Insights} />
      <Route path={`${match.url}/statement`} component={Statement} />
      <Route path={`${match.url}/invitations`} component={InvitationPage} />
      <Route path={`${match.url}/billing`} component={BillingPage} />
      <Route path={`${match.url}/botdialogs`} component={BotDialogPage} />
      <Route
        path={`${match.url}/sa`}
        component={SuperAdmin}
      />
      <Route
        path={`${match.url}/botdialogs/accommodationproviders`}
        component={AccommodationProvidersDialogPage}
      />
      <Route
        path={`${match.url}/botdialogs/doctors`}
        component={DoctorsDialogPage}
      />
      <Route
        path={`${match.url}/botdialogs/holidayhomes`}
        component={HolidayHomesDialogPage}
      />
      <Route
        path={`${match.url}/botdialogs/holidaypark`}
        component={HolidaysParkDialogPage}
      />
      <Route
        path={`${match.url}/botdialogs/quarantinebot`}
        component={QuarantineBotDialogPage}
      />

      <Route
        path={`${match.url}/botdialogs/salons`}
        component={SalonsDialogPage}
      />
      <Route
        path={`${match.url}/botdialogs/tourism`}
        component={TourismDialogPage}
      />
      <Route
        path={`${match.url}/botdialogs/vvn`}
        component={VirtualVetNurseDialogPage}
      />
      
      <Route
        path={`${match.url}/botdialogs/retirementhomes`}
        component={RetirementHomesDialogPage}
      />
      <Route path={`${match.url}/stripe`} component={StripePage}></Route>
      <Route path={`${match.url}/standard-stripe`} component={StandardStripe}></Route>      
      <Redirect to="/error" />
    </Switch>
  </div>
);
export default Pages;
